import { shutdown } from '@intercom/messenger-js-sdk';
import { useKindeAuth } from '@kinde-oss/kinde-auth-react';
import { deprecatedWithRouter } from 'HOC/deprecatedWithRouter';
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'src/lib/routing';

import { withAppContext } from 'components/HOCS';
import { LoadingOverlay } from 'components/common';
import { useIsKinde } from 'containers/Auth/AuthWrapper';
import { useConnectedClient } from 'context/ConnectedClientContext';
import { analytics } from 'lib/analytics';
import { localStorage } from 'lib/storage';
import { useResetUrqlClient } from 'network/urqlResetContext';
import { clearImpersonation } from 'utils/impersonation';

function Logout() {
  const resetUrql = useResetUrqlClient();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const { logout, isLoading } = useKindeAuth();
  const isKinde = useIsKinde();

  const connectedClient = useConnectedClient();

  useEffect(() => {
    const f = async () => {
      connectedClient.actions.clear();
      clearImpersonation();
      localStorage.reset();
      resetUrql();
      void analytics.reset();
      shutdown();

      if (isKinde) {
        await logout();
      } else {
        const redirectArgs = params.get('redirect') || '';
        const redirectUrl = `/${redirectArgs}`.replace(/,/g, '&');
        navigate({ pathname: redirectUrl }, { replace: true });
      }
    };

    if (isLoading && isKinde) {
      return;
    }

    void f();
  }, [isLoading, isKinde]);

  return <LoadingOverlay style={{ opacity: 0.8 }} />;
}

export default deprecatedWithRouter(withAppContext(Logout));
